import Weather from "./component/Weather";

function App() {
  return (
    <>
      <Weather/>
    </>
  );
}

export default App;
